import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/sa/agencies',
    name: 'agency-list',
    component: () => import('../views/agency/AgencyList.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/sa/agencies/create',
    name: 'agency-create',
    component: () => import('../views/agency/AgencyCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/sa/agencies/:id',
    name: 'agency-edit',
    component: () => import('../views/agency/AgencyEdit.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/sa/agencies/:id/providers',
    name: 'agency-providers',
    component: () => import('../views/agency/AgencyProviders.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/sa/providers-template',
    name: 'providers-template',
    component: () => import('../views/agency/ProviderTemplate.vue'),
    meta: { layout: appLayout }
  }
]
